import { Logout } from 'app/pages/common/logout/logout';
import Account from 'app/pages/desktop/account';
import { ClaimPage } from 'app/pages/desktop/claim/claim';
import { ClaimDetailsPage } from 'app/pages/desktop/claim/claim-details';
import { ContactPage } from 'app/pages/desktop/contact/contact';
import { ContractPage } from 'app/pages/desktop/contract/contract';
import { ContractDetailsPage } from 'app/pages/desktop/contract/contract-details';
import { HelpPage } from 'app/pages/desktop/help/help';

import AssignmentContract from 'app/modules/account/ui/components/common/assignement-contract/assignement-contract';
import NoMatchedAdhesion from 'app/modules/account/ui/components/common/no-matched-adhesion';
import SearchContract from 'app/modules/account/ui/components/common/search-contract/search-contract';
import FormContact from 'app/modules/contact/ui/components/desktop/contact-customer/upload-files-form-contact/upload.files.form.contact';
import paybox from 'app/modules/contract/ui/components/mobile/mobile-cotisation/payBox';
import AccountAssignementEngine from 'app/pages/common/account-assignement';
import { RouteComponentProps } from 'react-router-dom';

export const componentDesktopImportName = {
  Logout: Logout as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  ContractPage: ContractPage as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  ContractDetailsPage: ContractDetailsPage as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  FormContact: FormContact as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  ClaimDetailsPage: ClaimDetailsPage as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  ClaimPage: ClaimPage as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  ContactPage: ContactPage as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  Account: Account as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  HelpPage: HelpPage as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  paybox: paybox as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  SearchContract: SearchContract as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  AccountAssignementEngine: AccountAssignementEngine as
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>
    | undefined,
  AssignmentContract: AssignmentContract as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
  NonCorespondenceadhesion: NoMatchedAdhesion as React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> | undefined,
};
